export const apiUrl = import.meta.env.VITE_DJANGO_URL;

export const authHeaders = (): HeadersInit => {
  const token = localStorage.getItem('token');
  if (!token) {
    return {
      'Content-Type': 'application/json',
    };
  }
  return {
    'Content-Type': 'application/json',
    Authorization: 'Token ' + token,
  };
};

//
// ─── AUTHENTICATION ─────────────────────────────────────────────────────────────
//

export const userLogin = async (username, password) => {
  try {
    const resp = await fetch(apiUrl + '/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const json = await resp.json();
    localStorage.setItem('token', json.token);
    return json;
  } catch (error) {
    return error;
  }
};

export const getUser = async () => {
  try {
    const resp = await fetch(apiUrl + '/auth/user', {
      headers: authHeaders(),
    });
    const json = await resp.json();
    return json;
  } catch (error) {
    return error;
  }
};
